const filePlaceholderImage = "https://assets.bitbute.tech/public/client/file-placeholder.jpeg";
const threeDModelPlaceholderImage = "https://assets.bitbute.tech/public/client/3d-model-placeholder.jpeg";
const videoPlaceholderImage = 'https://assets.bitbute.tech/public/client/video-placeholder.png';
const imagePlaceholder = 'https://assets.bitbute.tech/public/client/placeholder-image.png';

export const FILE_TYPE = {
  type: "file",
  placeholderImage: filePlaceholderImage,
  allowedType: { "*/*": [""] },
};

export const IMAGE_TYPE = {
  type: "image",
  placeholderImage: imagePlaceholder,
  allowedType: { "image/*": [".jpg", ".png", ".jpeg", ".webp", ".svg"] },
};

export const VIDEO_TYPE = {
  type: "video",
  placeholderImage: videoPlaceholderImage,
  allowedType: { "video/*": [".mp4", ".mov"] },
};

export const THREE_D_MODEL_TYPE = {
  type: "3dModel",
  placeholderImage: threeDModelPlaceholderImage,
  allowedType: { "application/*": [".glb", ".gltf"] },
};

export const USDZ_MODEL_TYPE = {
  type: "usdzModel",
  placeholderImage: threeDModelPlaceholderImage,
  allowedType: { "application/*": [".usdz"] },
};

export const mediaTypes = [
  IMAGE_TYPE,
  VIDEO_TYPE,
  THREE_D_MODEL_TYPE,
  USDZ_MODEL_TYPE,
  FILE_TYPE,
];

export const getAllowedMediaType = (type) => {
  const fileType = mediaTypes.find((t) => type === t.type)?.allowedType;
  return fileType || {};
};

export const getMediaType = (type) => {
  const mediaType = mediaTypes.find((t) => type === t.type);
  return mediaType || null;
};

export const getMedia = (url, mimeType = "", type = "") => {
  if (type) {
    const mediaType = mediaTypes.find((t) => type === t.type);
    return mediaType || null;
  }

  const fileName = url;
  const fileExtension = "." + fileName.split(".").pop().toLowerCase();
  const fileType = mimeType;

  const currentType = mediaTypes.find((t) => {
    for (const [mimeType, allowedExtensions] of Object.entries(t.allowedType)) {
      if (
        fileType.startsWith(mimeType.split("/")[0]) ||
        allowedExtensions.includes(fileExtension)
      ) {
        return true;
      }
    }
    return false;
  });
  return currentType || FILE_TYPE;
};

export const getPlaceholderImage = (url, mediaType = "") => {
  if (mediaType) {
    return getMediaType(mediaType).placeholder;
  }
  const currentMedia = getMedia(url);
  return currentMedia ? currentMedia.placeholder : FILE_TYPE.placeholder;
};

export const isValidFileType = ({
  url,
  mimeType,
  mediaType,
  allowedTypesArr,
}) => {
  const fileExtension = "." + url.split(".").pop().toLowerCase();
  const type = mediaType ? getMediaType(mediaType) : getMedia(url, mimeType);
  if (!type) return false;
  const allowedTypeEntries = allowedTypesArr || getAllowedMediaType(type.type);

  return Object.entries(allowedTypeEntries).some(([t, allowedExtensions]) =>
    allowedExtensions.includes(fileExtension)
  );
};

export const getExpectedFileTypes = ({
  url,
  mimeType,
  mediaType,
  allowedTypesArr,
}) => {
  if (allowedTypesArr) {
    return Object.values(allowedTypesArr);
  } else {
    const media = mediaType ? getMediaType(mediaType) : getMedia(url, mimeType);
    return Object.values(media.allowedType);
  }
};
